$.validator.setDefaults({
    ignore: [],
});

$(window).on("load", function () {
    $(".loading-screen").fadeOut("slow");

    $(".loading-form").submit(function (e) {
        var formId = $(this).attr('id');
        if ($("#" + formId).valid()) {
            $("#" + formId + "-ajax-loader").show();
        }
    });

    $(".loading-form-no-recaptcha").submit(function (e) {
        var formId = $(this).attr('id');
        $("#" + formId + "-ajax-loader").show();
    });

    $(".ReCaptchaUtilSubmitButton").click(function (e) {
        e.preventDefault();
        var siteKey = $(this).attr('data-sitekey');
        var button = $(this);
        var form = $(this).closest('form');
        var formId = form.attr('id');
        button.attr('disabled', 'true');
        $('#' + formId + '-ajax-loader').show();

        grecaptcha.ready(function () {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
                SetSpamData();
                $('.GoogleReCaptchaToken').val(token);
                form.submit();
                button.removeAttr('disabled');
                $('#' + formId + '-ajax-loader').hide();
            });
        });
    });
});

$(document).ready(function () {
    //resends the email verification
    $("#btnVerifyEmail").click(function () {
        SendVerifyEmail($(this).attr("data-value"));
    });
});

function SendVerifyEmail(emailEncrypted) {
    $("#VerifyEmail-ajax-loader").show();
    $("#VerifyEmail-Success").hide();
    $("#VerifyEmail-Error").hide();

    $.get("/api/SiteApi/SendEmailVerificationEmail?emailEncrypted=" + emailEncrypted, function (data) {
        $("#VerifyEmail-ajax-loader").html(data);

        if (data == true) {
            $("#VerifyEmail-Success").show();
            setTimeout(function () {
                $("#VerifyEmail-Success").fadeOut("slow");
            }, 1000);
        }
        else {
            $("#VerifyEmail-Error").show();
            setTimeout(function () {
                $("#VerifyEmail-Error").fadeOut("slow");
            }, 1000);
        }

        $("#VerifyEmail-ajax-loader").hide();
    });
}

function ReCaptchaUtilEnableButton() {
    SetSpamData();
    $(".ReCaptchaUtilEnableButton").removeAttr("disabled");
}

function SetSpamData() {
    var enable = $(".SpamEnableIpLookup").val();
    var endpoint = $(".SpamIpLookupEndpoint").val();
    var key = $(".SpamIpLookupApiKey").val();
    if (enable == "True") {
        $.getJSON(endpoint + key, function (data) {
            var lookupAddress = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.ip));
            var lookupContinent = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.continent));
            var lookupCountry = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data.country));
            $(".LookupAddress").val(lookupAddress);
            $(".LookupContinent").val(lookupContinent);
            $(".LookupCountry").val(lookupCountry);
            console.log("Ip Address: " + data.ip);
            console.log("Continent: " + data.continent);
            console.log("Country: " + data.country);
        });
    }
}
